import moment from 'moment-timezone';

export function getFirstSchedulableDay(windowsMap, startDay = moment()) {
  while (
    !retrieveSchedulableWindows(windowsMap, startDay).length ||
    dayIsBooked(retrieveSchedulableWindows(windowsMap, startDay))
  ) {
    startDay.add(1, 'days');
  }

  return startDay;
}

export function getFirstAvailableShowedDay(schedulableWindows) {
  const window = Object.values(schedulableWindows).find(
    (windowCollection) => windowCollection.length > 0 && hasAvailable(windowCollection)
  );
  return getFirstAvailable(window);
}

export function getFirstShowedDay(schedulableWindows) {
  const window = Object.values(schedulableWindows).find(
    (windowCollection) => windowCollection.length > 0 && hasAvailable(windowCollection)
  );
  return getFirstAvailable(window);
}

export function dayIsBooked(windowsForDay) {
  if (windowsForDay.length === 0) {
    return false;
  }
  return windowsForDay.filter((window) => window.available).length === 0;
}

export function getInitialWindow(windowsMap, day) {
  const windows = retrieveSchedulableWindows(windowsMap, day);
  return windows[1] || windows[0];
}

export function getWeek(day) {
  const sunday = day.clone().day(0);
  const monday = day.clone().day(1);
  const tuesday = day.clone().day(2);
  const wednesday = day.clone().day(3);
  const thursday = day.clone().day(4);
  const friday = day.clone().day(5);
  const saturday = day.clone().day(6);

  return [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
}

export const getWeekAhead = (day = moment()) => {
  return new Array(7).fill(day.clone()).map((d, i) => d.clone().add(i, 'days'));
};

export const retrieveSchedulableWindows = (windowsMap, day = moment()) => {
  if (moment.isMoment(windowsMap)) {
    throw new Error('windowsMap must be an object literal, not a moment object.');
  }

  return windowsMap[day.format('YYYY-MM-DD')] || [];
};

export const displayTime = ({time, timeZone = moment.tz.guess()}) => {
  return moment(time).tz(timeZone).format('dddd, MMMM Do, h:mm A z');
};

export const displayRequestedTimeWindows = ({start, end, timeZone = moment.tz.guess()}) => {
  return `${moment(start).tz(timeZone).format('dddd, MMMM Do, h:mm A')} - ${moment(end).tz(timeZone).format('dddd, MMMM Do, h:mm A')}`;
};

export const displayTimeWindows = ({start, end, timeZone = moment.tz.guess(), calendar = defaultCalendar}) => {
  const startText = moment(start).tz(timeZone, true).calendar(null, calendar);
  const endText = moment(end).tz(timeZone, true).format('LT z');
  return `${startText} - ${endText}`;
};

export const formatAlternateScheduleTimes = (alternateScheduleTimes, preferredTime) => {
  return alternateScheduleTimes.map((time) => ({
    startTime: time.start.toISOString(),
    endTime: time.end.toISOString(),
    preferred: preferredTime.start === time.start,
  }));
};

const defaultCalendar = {
  sameDay: '[Today], LT z',
  nextDay: '[Tomorrow], LT, z',
  lastWeek: 'ddd, LL LT, z',
  nextWeek: 'ddd, LL LT, z',
  sameElse: 'ddd, LL LT, z',
};

function hasAvailable(windowCollection) {
  return windowCollection.filter((window) => window.available).length > 0;
}

function getFirstAvailable(windowCollection) {
  return windowCollection.filter((window) => window.available)[0].start;
}
